module.exports = __webpack_public_path__ + "img/menu.bacef632.svg";